import React from 'react';
import { CharmControl } from 'mini-charms';
import { EventCardCharmProps } from '../schema/EventCardCharm.types';
import { getEffectiveCharmId } from 'mini-charms/lib/utils/getEffectiveCharmId';
import { isNullOrUndefined } from 'mini-common-utils/lib/utils/isNullOrUndefined';

const commonStyles = require('./EventCardContent.scss');

/**
 * Renders the charm wrapper for the given item
 * @param item The item being rendered
 * @param isSmall
 */
export const EventCardCharm = (props: EventCardCharmProps): JSX.Element => {
    const { item, isSmall = false } = props;
    const effectiveCharmId = getEffectiveCharmId(
        item.CharmId,
        null /* TODO: Send parent calendar charm */,
        false /* fallback to no charm */
    );
    return isNullOrUndefined(effectiveCharmId) ? null : (
        <div
            className={isSmall ? commonStyles.charmWrapperSmall : commonStyles.charmWrapper}
            aria-hidden>
            <CharmControl
                className={commonStyles.charm}
                color={'inherit'}
                charmId={effectiveCharmId}
            />
        </div>
    );
};
